import sizes from './sizes'

export default {
  0: 0,
  s: sizes.border,
  m: 2,
}
